<template>
    <div class="about-page">
        <h1 class="title">About</h1>
        <table class="table is-bordered is-striped is-hoverable">
            <tr>
                <th>Version</th>
                <td>{{ version }}</td>
            </tr>
            <tr>
                <th>Commit id</th>
                <td>{{ commitId }}</td>
            </tr>
            <tr>
                <th>Build time</th>
                <td>{{ buildTime }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    name: "AboutPage",
    computed: {
        version() {
            return process.env.VUE_APP_VERSION || 'Undefined';
        },
        commitId() {
            return process.env.VUE_APP_COMMIT_ID || 'Undefined';
        },
        buildTime() {
            return new Date(process.env.VUE_APP_BUILD_TIME) || 'Undefined';
        }
    }
}
</script>

<style scoped>

</style>